module.exports = __webpack_public_path__ + "static/bag_of_devouring-527f04767fd89d34d23787128c583a44.jpeg";